import statuses from '@/components/_modules/Invoices/cells/statuses'
import AttachmentsDetails from '@/components/_modules/Invoices/cells/attachments-details'
import { hideForCancelledOrRejected } from '@/components/_modules/Invoices/statuses'

export default {
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'Id',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/send-action-required',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },

  'ProgramName': 'Project',

  'InvoiceStatus': {
    label: 'Status',
    source: 'PaymentInvoiceList_SentInvoices'
  },

  'TotalAmount': {
    label: 'Amount',
    getter: hideForCancelledOrRejected
  },

  'TotalPayment': 'Total Payments',

  'Balance': 'Balance',

  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },

  'DueDateWithinFormatted': {
    label: 'Due',
    getter: hideForCancelledOrRejected
  },
  'DueDateWithin': '_',

  'MediaCount': {
    label: 'Attachments',
    detailsCondition: showAttachmentsExpandIcon,
    details: 'invoice.getAttachmentsDetails',
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: AttachmentsDetails,
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'EventName': {
    label: 'Event',
    visible: false
  },
  'FirstEventEndDateFormatted': {
    label: 'Event End Date',
    visible: false
  },
  'FirstEventStartDateFormatted': {
    label: 'Event Start Date',
    visible: false
  },
  'InvoiceDateFormatted': {
    label: 'Invoice Date',
    visible: false
  },
  'PaymentStatus': {
    label: 'Invoice Status',
    source: 'PaymentInvoiceList_ReceivedInvoices',
    render: statuses,
    width: 270,
    visible: false
  },
  'PONumber': {
    label: 'PO',
    width: 180,
    visible: false
  },
  'ProgramEndDateFormatted': {
    label: 'Project End Date',
    visible: false
  },
  'ProgramStartDateFormatted': {
    label: 'Project Start Date',
    visible: false
  },
  'TotalReceived': {
    label: 'Received Payments',
    type: 'money',
    visible: false
  },
  'TotalUnprocessed': {
    label: 'Scheduled Payments',
    type: 'money',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  },
  'ReferenceCode': {
    label: 'Supplier Invoice Number',
    visible: false
  }
}

function showAttachmentsExpandIcon(params) {
  return params.data.MediaCount > 0
}

function getAttachmentsDetailsParams(params) {
  return `/${params.data.PaymentInvoiceID}?` +
    `&poId=${params.data.POID}` +
    `&poVersionId=${params.data.POVersionID}` +
    `&poType=${params.data.POType}` +
    `&programid=${params.data.ProgramID}`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Invoice-sent-cta/model.js